<template>
    <div class="hello-ezuikit-js">
        <div id="video-container"></div>
<!--        <div>{{ url }}</div>-->
    </div>
</template>

<script>
import EZUIKit from "ezuikit-js";

let player = null;
// let _this = null;

export default {
    name: "HelloWorld",
    data() {
        return {
            // url: '',
        }
    },
    created() {
        // _this = this
    },
    mounted: () => {
        // console.group("mounted 组件挂载完毕状态===============》");
        // _this.url = window.location.href
        let params = window.location.href.split('?accessToken=')[1].split('&url=')
        if (params.length == 2) {
            let width = document.documentElement.clientWidth;
            let height = document.documentElement.clientHeight;
            width > height ? width = height : null;
            player = new EZUIKit.EZUIKitPlayer({
                id: 'video-container', // 视频容器ID
                accessToken: params[0],
                url: params[1],
                // simple - 极简版; pcLive-pc直播；pcRec-pc回放；mobileLive-移动端直播；mobileRec-移动端回放;security - 安防版;voice-语音版;
                template: 'mobileRec',
                width: width,
                height: width * 3 / 4.3,
            });
            window.player = player;
        }

    },
    methods: {}
};
</script>
<style>
html,
body {
    padding: 0;
    margin: 0;
    /*text-align: center;*/
    /*background: #FFFFFF;*/
    /*overflow: hidden;*/
}
</style>